"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseDataMapper = /** @class */ (function () {
    function BaseDataMapper() {
    }
    BaseDataMapper.prototype.convertCollection = function (data) {
        var result = [];
        if (data && data.length) {
            for (var i in data) {
                var item = data[i];
                result.push(this.map(item));
            }
        }
        return result;
    };
    BaseDataMapper.prototype.map = function (payload) {
        var e_1, _a;
        if (payload[this.KEY_FIELD_NAME] == null) {
            throw new Error('Key field is null');
        }
        var key = payload[this.KEY_FIELD_NAME];
        var item = this.factory(key);
        try {
            for (var _b = __values(this.fieldMap.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), internalKey = _d[0], externalKey = _d[1];
                var value = null;
                if (externalKey != null) {
                    if (typeof externalKey === 'function') {
                        value = externalKey(payload, internalKey);
                    }
                    else {
                        value = payload[externalKey];
                    }
                }
                Object.defineProperty(item, internalKey, {
                    value: value
                });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return item;
    };
    ;
    return BaseDataMapper;
}());
exports.default = BaseDataMapper;
//# sourceMappingURL=base_data_mapper.js.map